import { ApplicationId } from "@1games-ru/region-shared/dist/enums/tablet/applicationd-id";
import { useTranslation } from "react-i18next";
import { DateInfo } from "@/core/constants/dateInfo";
import { imgTabletBackgroundScreen } from "@/shared/assets/img";
import { Icon } from "@/shared/ui";
import { applicationsInfo } from "@/domains/tablet/helpers/applicationsInfo";
import { useLaunchMarketplaceAppMutation } from "@/domains/tablet/hooks/useOpenMarketplace";

type Props = {
  appsList: ApplicationId[];
  currentTime: DateInfo;
  changeActiveApp: (appId: ApplicationId) => void;
  handleIconClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export default function TabletHomeScreen({
  appsList,
  currentTime,
  changeActiveApp,
  handleIconClick,
}: Props) {
  const { t } = useTranslation("tablet");
  const lauchMarketplaceMutation = useLaunchMarketplaceAppMutation();
  const { month, day, hours, minutes, weekday } = currentTime;

  const handleAppIcon = (event: React.MouseEvent<HTMLElement>, item: ApplicationId) => {
    if (item === ApplicationId.Marketplace) {
      lauchMarketplaceMutation.mutate();
      return;
    }

    changeActiveApp(item);
    handleIconClick(event);
  };

  return (
    <div
      className="flex flex-wrap size-full bg-no-repeat bg-cover"
      style={{ backgroundImage: `url(${imgTabletBackgroundScreen})` }}
    >
      <div className="w-full">
        <div className="flex w-full justify-between items-center mb-7.5 pt-4 px-3.5">
          <p className="text-13 font-medium">
            {hours}:{minutes}, {t(`days.${weekday}`)}, {day} {t(`months.${month}`)}
          </p>
          <div className="flex items-center gap-1.5">
            <Icon name="signal" category="tablet" className="w-4.5" />
            <Icon name="wifi" category="tablet" className="w-4" />
            <Icon name="battery" category="tablet" className="w-6" />
          </div>
        </div>
        <div className="flex flex-wrap gap-10 w-full px-8">
          {appsList.map((item) => (
            <button
              key={applicationsInfo[item]?.name}
              className="flex flex-col items-center w-[6.875rem]"
              onClick={(event) => handleAppIcon(event, item)}
              type="button"
            >
              <div
                className="w-18 h-18 mb-1.5 rounded-[1.25rem] bg-white bg-contain"
                style={{
                  backgroundImage:
                    applicationsInfo[item]?.icon && `url(${applicationsInfo[item]?.icon})`,
                }}
              />
              <p className="text-15 font-medium">{applicationsInfo[item]?.name}</p>
            </button>
          ))}
        </div>
      </div>
      <div className="mt-auto mb-7.5 mx-auto">
        <div className="flex justify-center gap-2.5 mb-5">
          <div className="w-2 h-2 bg-white rounded-xl" />
          <div className="w-2 h-2 bg-white/50 rounded-xl" />
          <div className="w-2 h-2 bg-white/50 rounded-xl" />
        </div>
        <div className="flex justify-center gap-4 p-2.5 rounded-[1.75rem] bg-dark-800/40">
          <div className="w-18 h-18 bg-white rounded-[1.25rem]" />
          <div className="w-18 h-18 bg-white rounded-[1.25rem]" />
          <div className="w-18 h-18 bg-white rounded-[1.25rem]" />
        </div>
      </div>
    </div>
  );
}
